import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CONFIRM_TYPE_DANGER, CONFIRM_TYPE_INFO } from '../../../models/dialog';

export class ConfirmOptions {
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  confirmType: string;
}

@Component({
  selector: 'velocity-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialog implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit() {
  }

  public getColor(confirmType: string) {
    if (confirmType === CONFIRM_TYPE_DANGER) {
      return 'warn';
    }

    if (confirmType === CONFIRM_TYPE_INFO) {
      return 'default';
    }

    return 'primary';
  }
}
